import { useEffect } from "react";
import ValidationManager from "./validationManager";
import Validator from "./Validator";
import formHelper from "../../util/formHelper";
import ServiceArea from "../../models/serviceArea";

const ServiceAreaEdit: React.FC<{
  item: ServiceArea;
  onChange: any;
  isNew: boolean;
  validationManager: ValidationManager;
  validationId: string;
}> = ({
  item: serviceArea,
  onChange,
  isNew,
  validationManager,
  validationId,
}) => {
  const validator = {
    cityName: `${validationId}_cityName`,
    zipCode: `${validationId}_zipCode`,
    radius: `${validationId}_radius`,
  };

  useEffect(() => {
    // const init = async () => {
    //   try {

    //   } catch (error) {
    //     // TODO: show error with toastr
    //   }
    // };

    if (!isNew) {
      validationManager.setIsValid(validator.cityName, true);
      validationManager.setIsValid(validator.zipCode, true);
      validationManager.setIsValid(validator.radius, true);
    }

    //init();
  }, [
    validationManager,
    isNew,
    validator.cityName,
    validator.zipCode,
    validator.radius,
  ]);

  const onServiceAreaChange = (event: any) => {
    const { id, name, value } = formHelper.getDataFromEvent(event.target);
    const newServiceArea = { ...serviceArea, [name]: value };
    onChange(newServiceArea);

    if (id === validator.cityName) {
      const isValid = value.length !== 0;
      validationManager.setIsValid(validator.cityName, isValid);
    }

    if (id === validator.zipCode) {
      const isValid = value.length !== 0;
      validationManager.setIsValid(validator.zipCode, isValid);
    }

    if (id === validator.radius) {
      const isValid = value.length !== 0;
      validationManager.setIsValid(validator.radius, isValid);
    }
  };

  return (
    <>
      <div className="col-md-3 mb-3">
        <Validator
          name={validator.cityName}
          errorMessage="Please enter a city name."
          validationManager={validationManager}
        >
          <div>
            <label htmlFor="cityName" className="form-label">
              City
            </label>
            <input
              type="text"
              className="form-control"
              id={`${validationId}_cityName`}
              name={formHelper.nameOf<ServiceArea>((t) => t.cityName)}
              value={serviceArea.cityName}
              onChange={onServiceAreaChange}
            />
          </div>
        </Validator>
      </div>
      <div className="col-md-3 mb-3">
        <Validator
          name={validator.zipCode}
          errorMessage="Please enter a zip code."
          validationManager={validationManager}
        >
          <div>
            <label htmlFor="zipCode" className="form-label">
              Zip Code
            </label>
            <input
              type="text"
              className="form-control"
              id={`${validationId}_zipCode`}
              name={formHelper.nameOf<ServiceArea>((t) => t.zipCode)}
              value={serviceArea.zipCode}
              onChange={onServiceAreaChange}
            />
          </div>
        </Validator>
      </div>

      <div className="col-md-3 mb-3">
        <Validator
          name={validator.radius}
          errorMessage="Please enter a radius."
          validationManager={validationManager}
        >
          <div>
            <label htmlFor="radius" className="form-label">
              Radius
            </label>
            <input
              type="text"
              className="form-control"
              id={`${validationId}_radius`}
              name={formHelper.nameOf<ServiceArea>((t) => t.radius)}
              value={serviceArea.radius}
              onChange={onServiceAreaChange}
            />
          </div>
        </Validator>
      </div>
    </>
  );
};

export default ServiceAreaEdit;
